module.exports = __webpack_public_path__ + "img/tip1.1a4cd723.png";